import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { AllegatiComponent } from './components/allegati.component';
import { TranslateModule } from '../translate/translate.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { VisualizzaDettagliComponent } from './components/visualizza-dettagli/visualizza-dettagli.component';

@NgModule({
	declarations: [
		AllegatiComponent,
		VisualizzaDettagliComponent
	],
	imports: [
		CommonModule,
		HttpClientModule,
		MatTableModule,
		TranslateModule,
		MatExpansionModule,
		NgxJsonViewerModule
	],
	exports: [AllegatiComponent],
	providers: [],
})
export class AllegatiModule {}